module.exports = __webpack_public_path__ + "static/media/msexcel.d2669b14.png";